import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import { startsWith, some } from "lodash"
import OPTooltip from "components/material/tooltip"
import { VerticalSplit } from "@mui/icons-material"
import { IconButton, Badge } from "@mui/material"
import { MetricsTemplateShape } from "components/custom-metrics-selector/helpers/prop-types"
import { useHasResourcePermission } from "hooks/permissions"
import { PERMISSION_LEVELS } from "helpers/permissions"
import { useMetricsSelectorAnalytics } from "components/custom-metrics-selector/hooks/use-metrics-selector-analytics"

export default function CustomHeader({ templateMetadata, context }) {
  const assetViewContext = useContext(context)
  const { setShowMetricsSelector, showMetricsSelector, modelId } = assetViewContext
  const analytics = useMetricsSelectorAnalytics(assetViewContext)

  const hasHiddenCustomMetrics = useMemo(() => {
    const metrics = templateMetadata?.config.metrics
    if (!metrics) {
      return false
    }
    return some(metrics, metric => {
      if (!startsWith(metric, "model")) {
        return false
      }
      const model = metric.split(".")[1]
      if (model !== modelId) {
        return true
      }
      return false
    })
  }, [templateMetadata, modelId])

  const canEditColumns = useHasResourcePermission(templateMetadata, PERMISSION_LEVELS.WRITE)
  if (templateMetadata && !canEditColumns) {
    return null
  }

  const handleMetricsSelectorClick = () => {
    if (!showMetricsSelector) {
      analytics?.trackOpened?.(templateMetadata)
    }
    setShowMetricsSelector(!showMetricsSelector)
  }

  let tooltip = "Edit Columns"
  if (hasHiddenCustomMetrics) {
    tooltip += " - Some selected metrics may currently be unavailable"
  }

  // [TODO] find better solution for alignment
  return <OPTooltip title={tooltip}>
    <IconButton className="column-button" onClick={handleMetricsSelectorClick}>
      <Badge color="warning" variant="dot" invisible={!hasHiddenCustomMetrics}>
        <VerticalSplit />
      </Badge>
    </IconButton>
  </OPTooltip>
}

CustomHeader.propTypes = {
  templateMetadata: MetricsTemplateShape,
  context: PropTypes.object.isRequired,
}
